import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Hero } from '../components/landing/Hero';
import { BridgeSection } from '../components/landing/BridgeSection';
import { DemoConversation } from '../components/landing/DemoConversation';
import { PathsFinder } from '../components/landing/PathsFinder';
import { MobileShowcase } from '../components/landing/MobileShowcase';
import { Walkthrough } from '../components/landing/Walkthrough';
import { Testimonials } from '../components/landing/Testimonials';
import { PriceAnchor } from '../components/landing/PriceAnchor';
import { PricingCard } from '../components/landing/PricingCard';
import { FAQ } from '../components/landing/FAQ';
import { FooterSafety } from '../components/landing/FooterSafety';
import { tracking } from '../utils/tracking';

export function LandingPage() {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'VZMO - AI Life Coach | Free AI Coaching for Career & Life';

    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        'Get personalized AI life coaching for career decisions, relationship guidance, and personal growth. Better than meditation apps. Private journaling with AI insights. 7-day free trial.'
      );
    }

    window.scrollTo(0, 0);
  }, []);

  const handleStartFree = (source: string = 'hero') => {
    tracking.startFreeClicked(source);
    navigate('/signup');
  };

  const handleSeeHowItWorks = () => {
    tracking.seeHowItWorksClicked();
    const element = document.getElementById('how-it-works');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handlePricingCTA = () => {
    tracking.pricingPrimaryCTAClicked();
    handleStartFree('pricing');
  };

  return (
    <div className="min-h-screen bg-white">
      <Hero
        onStartFree={() => handleStartFree('hero')}
        onSeeHowItWorks={handleSeeHowItWorks}
      />

      <BridgeSection onStartFree={() => handleStartFree('bridge')} />

      <DemoConversation onStartFree={() => handleStartFree('demo')} />

      <PathsFinder />

      <MobileShowcase onStartFree={() => handleStartFree('mobile-showcase')} />

      <Walkthrough />

      <PriceAnchor />

      <Testimonials />

      <PricingCard onStartFree={handlePricingCTA} />

      <FAQ onStartFree={() => handleStartFree('faq')} />

      <FooterSafety onStartFree={() => handleStartFree('footer')} />
    </div>
  );
}
